<template>
    <div :style="style()" :key="renderKey">
        <div v-if="toInputField()">
            <FormField
                :id="id"
                :name="id"
                :access="solveFormula('access', access)"
                :items="fieldCatalogItems()"
                :value="value"
                :dictionary="fieldDictionary()"
                :prefix="solveFormula('prefix', queryField.prefix)"
                :suffix="solveFormula('suffix', queryField.suffix)"
                :rules="fieldRules()"
                :permission="permission"
                :generalExApplicationEx="generalExApplicationEx"
                :customLanguage="customLanguage"
                :queryFlag="true"
                :renderKey="renderKey"
                :coordinates="coordinates"
                :length="
                    queryField.length
                        ? queryField.length
                        : findDictionary(screen, queryField.dictionaryName)
                              .length
                "
                :secLength="
                    queryField.secLength
                        ? queryField.secLength
                        : findDictionary(screen, queryField.dictionaryName)
                              .secLength
                "
                :dictionaryngList="dictionaryingList"
                :catalogingList="catalogingList"
                ref="formField"
                @handle-change="handleChange"
            />
        </div>
        <div v-else>
            <div v-if="!loading">
                <v-dialog v-model="showPreviewDialog" max-width="500">
                    <v-card>
                        <v-img
                            v-if="pictureField(fieldDictionary())"
                            :src="url"
                            :lazy-src="url"
                        />
                        <pdfvuer
                            v-if="pdfField(fieldDictionary())"
                            :src="url"
                            :scale="'page-width'"
                        />
                    </v-card>
                </v-dialog>
                <!-- Normal -->
                <div
                    v-show="
                        fieldAccess() != 'hidden' &&
                        !fileInputField(fieldDictionary()) &&
                        !checkField(fieldDictionary()) &&
                        !comboTagField(fieldDictionary())
                    "
                    :class="
                        fieldAlign({ dictionary: fieldDictionary(), screen })
                    "
                >
                    <strong v-if="label">{{ label }}:</strong>
                    {{ formatQueryField() }}
                    <v-icon
                        v-if="
                            iconCatalogItem(
                                fieldDictionary(),
                                solveFormula('value', value),
                                items
                            )
                        "
                        :color="
                            iconCatalogItem(
                                fieldDictionary(),
                                solveFormula('value', value),
                                items
                            ).color
                        "
                        >{{
                            iconCatalogItem(
                                fieldDictionary(),
                                solveFormula("value", value),
                                items
                            ).icon
                        }}</v-icon
                    >
                </div>

                <!-- Check -->
                <CheckField
                    v-if="checkField(fieldDictionary())"
                    :id="id"
                    :access="fieldAccess()"
                    :value="value"
                    :align="'center'"
                    :query="true"
                />

                <!-- Preview -->
                <div
                    v-if="
                        fieldPreview(fieldDictionary(), value)
                        //pictureField(fieldDictionary()) && preview && !emptyString(value)
                    "
                    :class="
                        fieldAlign({ dictionary: fieldDictionary(), screen })
                    "
                >
                    <v-badge
                        color="grey"
                        :content="getFileExtensionExt(value)"
                        inline
                        overlap
                    >
                        <v-avatar
                            v-if="pictureField(fieldDictionary())"
                            color="rgba(0, 0, 0, 0.2)"
                            height="80"
                            width="80"
                        >
                            <v-img
                                v-if="pictureField(fieldDictionary())"
                                :src="url"
                                :lazy-src="url"
                                contain
                            />
                        </v-avatar>
                        <v-btn @click="doPreview()" icon>
                            <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                    </v-badge>
                </div>

                <!-- Tags -->
                <div
                    v-if="comboTagField(fieldDictionary())"
                    :class="
                        fieldAlign({ dictionary: fieldDictionary(), screen })
                    "
                >
                    <v-chip v-for="tag in comboTagsValues()" :key="tag" x-small>
                        {{ tag }}
                    </v-chip>
                </div>

                <!-- Progress -->
                <div
                    v-if="progressField(fieldDictionary())"
                    :class="
                        fieldAlign({ dictionary: fieldDictionary(), screen })
                    "
                >
                    <v-progress-linear
                        :value="value"
                        :color="
                            value == 100 ? 'grey darken-2' : 'grey lighten-1'
                        "
                    >
                    </v-progress-linear>
                </div>
            </div>
            <div v-else>
                <!-- Loading -->
                <div
                    :class="
                        fieldAlign({ dictionary: fieldDictionary(), screen })
                    "
                >
                    <v-progress-linear indeterminate height="10" rounded>
                    </v-progress-linear>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CheckField from "./CheckField";
import PSD from "psd.js/dist/psd.min.js";
import FormField from "./FormField";
import pdfvuer from "pdfvuer";
export default {
    name: "QueryField",
    props: [
        "id",
        "dictionary",
        "items",
        "value",
        "coordinates",
        "access",
        "preview",
        "permission",
        "method",
        "label",
        "generalExApplicationEx",
        "customLanguage",
        "loading",
        "screen",
        "queryField",
        "queryRecord",
        "environment",
        "renderKey",
        "queryExtended",
        "dictionaryingList",
        "catalogingList",
    ],
    data() {
        return {
            url:
                this.queryExtended && this.queryExtended.url
                    ? this.queryExtended.url
                    : this.value,
            showPreviewDialog: false,
        };
    },
    components: {
        CheckField,
        FormField,
        pdfvuer,
    },
    methods: {
        style() {
            const spreadColor = this.spreadColorCatalogItem(
                this.fieldDictionary(), //this.dictionary,
                this.value,
                this.items
            );
            return spreadColor
                ? null //"background-color: " + this.hexaColor(spreadColor)
                : null;
        },
        formatQueryField() {
            var formatted = this.value;

            if (this.queryField.valueFormula) {
                formatted = this.solveFormula("value", this.value);
            }

            const dictionary = this.fieldDictionary(); //this.dictionary;

            if (this.dateField(dictionary)) {
                formatted = this.formatDate(formatted);
            } else if (this.dateTimeField(dictionary)) {
                formatted = this.formatDateTime(formatted);
            } else if (this.numberField(dictionary)) {
                formatted = this.formatReal(
                    formatted,
                    this.queryField.length
                        ? this.queryField.length
                        : dictionary.length,
                    this.queryField.secLength
                        ? this.queryField.secLength
                        : dictionary.secLength
                );
            } else if (this.handleAsCatalog(dictionary)) {
                const inputData = this.basicBuildInputData(
                    this.queryField.inputFields,
                    this.queryRecord
                );
                const catalogEx = this.findCatalogEx(
                    this.screen,
                    dictionary.name,
                    inputData
                );
                if (catalogEx) {
                    const item = this.findCatalogItem(
                        dictionary,
                        formatted,
                        catalogEx.items //this.items
                    );
                    if (item) {
                        formatted = this.translatedConfig(
                            this.generalExApplicationEx,
                            this.customLanguage,
                            item,
                            "itemName"
                        );
                    } else {
                        formatted = null;
                    }
                }
            } else if (this.checkField(dictionary) == true) {
                formatted = null;
            }

            const suffix = this.solveFormula("suffix", this.queryField.suffix);
            const prefix = this.solveFormula("prefix", this.queryField.prefix);

            formatted = formatted
                ? (prefix ? prefix + " " : "") +
                  formatted +
                  (suffix ? " " + suffix : "")
                : null;

            return formatted;
        },
        setImageUrl() {
            const dictionary = this.fieldDictionary(); //this.dictionary;
            if (this.pictureField(dictionary)) {
                this.url =
                    this.queryExtended && this.queryExtended.url
                        ? this.queryExtended.url
                        : this.value;
                if (this.isFilePsd(this.url)) {
                    PSD.fromURL(this.url)
                        .then((psd) => {
                            this.url =
                                psd.image.toPng().attributes["src"].value;
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                }
            }
        },
        fieldAccess() {
            return this.getFieldAccess(
                this.access,
                this.permission,
                this.method
            );
        },
        doPreview() {
            this.showPreviewDialog = !this.showPreviewDialog;
        },
        toInputField() {
            return ["required", "optional"].includes(this.fieldAccess());
        },
        solveFormula(key, base) {
            const formula = this.queryField[key + "Formula"];
            if (formula) {
                const data = this.queryRecord;
                const result = eval(formula, data);
                return result;
            } else {
                return base;
            }
        },

        fieldDictionaryName() {
            const dictionaryName = this.solveFormula(
                "dictionary",
                this.queryField.dictionaryName
            );
            return dictionaryName;
        },

        fieldDictionary() {
            return this.findDictionary(this.screen, this.fieldDictionaryName());
        },

        fieldCatalogItems() {
            return this.findCatalogExList(
                this.screen,
                this.fieldDictionaryName(),
                this.basicBuildInputData(
                    this.queryField.inputFields,
                    this.queryRecord
                )
            );
        },

        fieldRules() {
            let rules = [];

            const dictionary = this.findDictionary(
                this.screen,
                this.queryField.dictionaryName
            );
            const dataType = dictionary.dataType;
            const checkField = this.checkField(dictionary);
            const comboField = this.comboField(dictionary);
            const dateField = this.dateField(dictionary);
            const fieldName = this.queryField.fieldName;

            // Access rules
            let access = this.getFieldAccess(
                this.queryField.access,
                this.permission,
                this.transactionMethod
            );
            switch (access) {
                case "required": {
                    let rule = (v) =>
                        !!v || this.translatedText("requiredFieldText");
                    rules.push(rule);
                    break;
                }
            }
            // Check rules
            if (this.checkField(dictionary) && access == "required") {
                let rule = (v) =>
                    v === true || this.translatedText("invalidFieldText");
                rules.push(rule);
            }

            // Min Max Rules Integer
            const integer = this.fieldInteger(dataType);
            if (integer && !checkField && !comboField && !dateField) {
                const maximum = this.queryField.max;
                if (maximum && maximum > 0) {
                    let rule = (v) => v <= maximum || "Max: " + maximum;
                    rules.push(rule);
                }
            }

            if (integer && !checkField && !comboField && !dateField) {
                const minimum = this.queryField.min;
                if (minimum != null) {
                    let rule = (v) => v >= minimum || "Min: " + minimum;
                    rules.push(rule);
                }
            }

            // Min Max Rules Real
            const real = this.fieldReal(dataType);
            if (real && !checkField && !comboField && !dateField) {
                const maximum = parseFloat(this.queryField.max);
                if (this.queryField.max && maximum > 0) {
                    let rule = (v) =>
                        parseFloat(v) <= maximum || "Max: " + maximum;
                    rules.push(rule);
                }
            }

            if (real && !checkField && !comboField && !dateField) {
                const minimum = parseFloat(this.queryField.min);
                if (this.queryField.min != null) {
                    let rule = (v) =>
                        parseFloat(v) >= minimum || "Min: " + minimum;
                    rules.push(rule);
                }
            }

            // Validation Formula
            const validationFormula = this.queryField.validationFormula;
            if (validationFormula) {
                let rule = (v) => {
                    let data = this.allFormData();
                    data[fieldName] = v;
                    return (
                        eval(validationFormula, data) ||
                        this.translatedText("invalidFieldText")
                    );
                };
                rules.push(rule);
            }
            return rules;
        },

        handleChange(data) {
            this.$emit("handle-change", data);
        },

        comboTagsValues() {
            let formatted = this.value;
            if (this.queryField.valueFormula) {
                formatted = this.solveFormula("value", this.value);
            }
            const values = this.comboTagListField(this.fieldDictionary())
                ? formatted
                : formatted
                ? formatted.split(",")
                : [];
            const items = this.fieldCatalogItems();
            const stringValues = values.map((value) => {
                const item = items
                    ? items.find((item) => {
                          return item.itemId == value;
                      })
                    : null;
                if (item) {
                    const caption = this.translatedConfig(
                        this.generalExApplicationEx,
                        this.customLanguage,
                        item,
                        "itemName"
                    );
                    return caption;
                } else {
                    return value;
                }
            });
            return stringValues;
        },

        setValue(args) {
            if (this.toInputField() && this.$refs.formField) {
                this.$refs.formField.setValue(args.value, args.autoSource);
            }
        },
    },

    mounted() {
        this.setImageUrl();
    },
    updated() {},
};
</script>

<style>
</style>